import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../lib/client.js';
import { menuItemsQuery } from '../lib/queries.js';

function OverlayMenu({ isOpen, onClose }) {
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    client.fetch(menuItemsQuery)
      .then(setMenuItems)
      .catch(console.error);
  }, []);

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-100 z-[11000] transform transition-transform duration-200 ease-in-out ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      {/* Desktop image grid */}
      <div className="hidden md:grid grid-cols-3 auto-rows-fr w-full h-full">
        {menuItems.map((item) => (
          <Link
            key={item._id}
            to={item.slug}
            onClick={onClose}
            className="relative group w-full h-full"   // each cell fills its grid slot
          >
            <img
              src={item.imageUrl}
              alt={`${item.title} Image`}
              className="w-full h-full object-cover transition-all duration-200 group-hover:blur-[1.5px]"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-3xl italic opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-customNavy">
                {item.title}
              </span>
            </div>
          </Link>
        ))}
      </div>


      {/* Mobile simple text links */}
      <div className="flex flex-col items-center justify-center h-full md:hidden">
        {menuItems.map((item) => (
          <Link
            key={item._id}
            to={item.slug}
            className="text-xl font-semibold mb-4 text-customNavy"
            onClick={onClose}
          >
            {item.title}
          </Link>
        ))}
      </div>

      {/* X Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-2xl text-customNavy"
        aria-label="Close menu"
      >
        &times;
      </button>
    </div>
  );
}

export default OverlayMenu;
